/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Accept_ConfirmInputs */

const en_us2_draft_accept_confirm = /** @type {(inputs: Draft_Accept_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept and activate`)
};

const pt_br2_draft_accept_confirm = /** @type {(inputs: Draft_Accept_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitar e ativar`)
};

const es_419_draft_accept_confirm = /** @type {(inputs: Draft_Accept_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar y activar`)
};

const pt_pt2_draft_accept_confirm = /** @type {(inputs: Draft_Accept_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitar e ativar`)
};

const fr_fr2_draft_accept_confirm = /** @type {(inputs: Draft_Accept_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter et activer`)
};

const de_de2_draft_accept_confirm = /** @type {(inputs: Draft_Accept_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übernehmen und aktivieren`)
};

const it_it2_draft_accept_confirm = /** @type {(inputs: Draft_Accept_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetta e attiva`)
};

/**
* | output |
* | --- |
* | "Accept and activate" |
*
* @param {Draft_Accept_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_accept_confirm = /** @type {((inputs?: Draft_Accept_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Accept_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_accept_confirm(inputs)
	if (locale === "es-419") return es_419_draft_accept_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_accept_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_accept_confirm(inputs)
	if (locale === "de-DE") return de_de2_draft_accept_confirm(inputs)
	if (locale === "it-IT") return it_it2_draft_accept_confirm(inputs)
	return en_us2_draft_accept_confirm(inputs)
});
export { draft_accept_confirm as "draft.accept_confirm" }